<template>
  <div class="flex items-center cursor-pointer">
    <input :id="$attrs.id"
           v-model="model"
           type="checkbox"
           class="form-checkbox h-4 w-4 text-secondary transition duration-150 ease-in-out"/>
    <label :for="$attrs.id"
           class="ml-2 block text-sm leading-5 text-gray-900 select-none cursor-pointer">
      <slot name="label">
        {{label}}
      </slot>
    </label>
  </div>
</template>
<script>
  export default {
    name: 'base-checkbox',
    inheritAttrs: false,
    props: {
      value: {
        type: [Boolean, String, Number],
        description: 'Switch value'
      },
      label: {
        type: String,
        default: ''
      }
    },
    computed: {
      model: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
<style>
</style>
